import type { ReactNode } from 'react';

export const symbol_high_chair: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M273-120q-14 0-23-9.5t-7-23.5l38-408-34-196q-4-24 12.5-53.5T330-840q57 0 101 35.5t54 92.5l20 119h185q13 0 21.5 8.5T720-563q0 13-8.5 21.5T690-533h-51l35 380q2 13-7 23t-23 10q-11 0-20-8t-10-19l-5-56H308l-6 56q-1 11-9.5 19t-19.5 8Zm57-473h114l-19-109q-6-35-33-56.5T330-780h-26l26 187Zm0 0h114-114Zm-17 330h291l-10-105H323l-10 105Zm15-165h260l-9-105H338l-10 105Z"
		/>
	</svg>
);
